import config from "../boot/config";
import moment from "moment";
import { ManualPromise } from "../utils";
import HttpPendingRequestTracker from "./httpPendingRequestTracker";

const TIMEOUT = 90000; // 90 seconds

/**
 *
 * HTTP call
 *
 * @param {object} httpObject {
 *    url,
 *    method, //ie 'GET', 'POST' etc
 *    params, //query string objects optional
 *    data, //body data optional
 *    headers, //optional header overrider
 *    cacheOptions // api cache options
 *
 *    //all other items passed will be put into the query string
 *}
 * @param {bool} addNullToParams add any undefined or null params to the query string as 'param='
 * @param {ManualPromise} canceller pass a ManualPromise that if rejected, cancelles the request
 * @param {bool} useTimeout default true
 */
export default async function http(
	httpObject,
	addNullToParams = false,
	canceller = new ManualPromise(),
	useTimeout = true
) {
	let { url, method, data, headers, isCustom, cacheOptions, ...params } = httpObject;

	if (!canceller) {
		canceller = new ManualPromise();
	}

	let token = await localStorage.getItem(config.tokenKey);
	let setHeaders = headers || {
		Accept: "application/json",
		"Content-Type": "application/json"
	};

	if (cacheOptions && cacheOptions.useCache) {
		setHeaders["X-Cacheable"] = "true";

		if (cacheOptions.refreshAtTimeUtc) {
			setHeaders["X-Cache-Refresh-At-Time"] = cacheOptions.refreshAtTimeUtc;
		}
		if (cacheOptions.refreshIntervalMins) {
			setHeaders["X-Cache-Refresh-Every-X-Mins"] = cacheOptions.refreshIntervalMins;
		}
		if (cacheOptions.deleteAfterInactiveDays) {
			setHeaders["X-Cache-Delete-After-X-Days"] = cacheOptions.deleteAfterInactiveDays;
		}
	}

	if (token) {
		params.jwt = token; //ibms puts jwt in querystring
		setHeaders.Authorization = "Bearer " + token;
	}

	if (!isEmpty(params)) {
		const querys = serialize(params, addNullToParams);
		if (querys) {
			if (isCustom) {
				url = url + "&" + querys;
			} else {
				url = url + "?" + querys;
			}
		}
	}

	let body;
	if (data) {
		if (typeof data === "string" || data instanceof FormData || data instanceof Blob) {
			//dont stringify a string or certian objects
			body = data;
		} else {
			body = JSON.stringify(data);
		}
	}

	// if (config.debug) {
	//    console.log(`HTTP: ${method} ${url} ${body ? "\n" + body : ""}`);
	// }

	return new Promise((resolve, reject) => {
		let xhr = new XMLHttpRequest();
		let cancelled = false;

		//kill http if canceller is rejected
		canceller.then(
			() => null,
			() => {
				cancelled = true;
				xhr.abort();
			}
		);

		xhr.onreadystatechange = function() {
			if (xhr.readyState === XMLHttpRequest.DONE) {
				// if (config.debug) {
				//    console.log(`Request done: ${xhr.status} ${method} ${url} \n`);
				// }
				if (xhr.status === 200) {
					if (xhr.responseText) {
						canceller.Resolve();
						resolve(convertDate(JSON.parse(xhr.responseText)));
					} else {
						canceller.Resolve();
						resolve();
					}
				} else {
					canceller.Resolve();
					let respMsg =
						"HTTP Error " +
						xhr.status +
						" " +
						xhr.statusText +
						" " +
						xhr.responseURL +
						" _RESPONSE_" +
						xhr.responseText;
					reject(new Error(cancelled ? "HTTP Cancelled" : respMsg));
				}
			}
		};
		xhr.open(method, url, true);

		if (useTimeout) {
			xhr.timeout = TIMEOUT;
		}

		for (var p in setHeaders) {
			if (setHeaders.hasOwnProperty(p)) {
				xhr.setRequestHeader(p, setHeaders[p]);
			}
		}

		xhr.send(body);
	});
}

function convertDate(response) {
	if (response != null) {
		if (typeof response !== "object") return response;
		var data = response,
			key,
			value;
		for (key in data) {
			value = data[key];
			if (typeof value === "string") {
				if (
					value != null &&
					value.length >= 19 &&
					moment(value.substr(0, 19), "YYYY-MM-DDTHH:mm:ss", true).isValid()
				) {
					data[key] = moment.utc(value).toDate();
				}
			} else {
				if (typeof value === "object") {
					convertDate(value); // Recursively process any objects
				}
			}
		}
	}
	return response;
}

function isEmpty(obj) {
	if (!obj) {
		return true;
	}

	if (typeof obj === "object") {
		for (var p in obj) {
			if (obj.hasOwnProperty(p)) {
				return false;
			}
		}
	}
	return true;
}

function serialize(obj, addNull) {
	var str = [];
	for (var p in obj)
		if (obj.hasOwnProperty(p)) {
			if (typeof obj[p] !== "object" || obj[p] === null) {
				const value = obj[p] !== null && obj[p] !== undefined ? encodeURIComponent(obj[p]) : "";
				if (value || value === 0 || addNull) {
					str.push(encodeURIComponent(p) + "=" + value);
				}
			} else {
				str.push(serialize(obj[p], addNull));
			}
		}
	return str.join("&");
}



// WEBPACK FOOTER //
// ./src/boot/http.js